import React, { useEffect, useRef, useImperativeHandle, forwardRef } from "react";
import QRCodeStyling from "qr-code-styling";

const StyledQRCode = forwardRef(({ options }, forwardedRef) => {
  const containerRef = useRef(null);
  const qrCodeInstance = useRef(null);

  useImperativeHandle(forwardedRef, () => ({
    download: (downloadOptions) => {
      if (qrCodeInstance.current) {
        qrCodeInstance.current.download(downloadOptions);
      } else {
        console.error("QR Code instance not available for download.");
      }
    },
  }));

  useEffect(() => {
    if (containerRef.current && options) {
      if (!qrCodeInstance.current) {
        qrCodeInstance.current = new QRCodeStyling(options);
        qrCodeInstance.current.append(containerRef.current);
      } else {
        qrCodeInstance.current.update(options);
      }
    }
  }, [options]);

  return <div ref={containerRef} />;
});

export default StyledQRCode;